import React, { useState } from "react";
import { API_BASE_URL } from "../../config";

// Dropped into both profile pages. Until this existed the only way to change a
// password was the forgotten-password email flow, which needs a mail provider
// configured -- so on a host with MAIL_PROVIDER=log there was no way at all.
//
// The current password is required. A signed-in session is not proof that the
// person at the keyboard owns the account: a borrowed laptop or an unlocked
// screen is a valid session too, and without the check any of them could set a
// new password and lock the owner out for good.

export default function ChangePassword() {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ current_password: "", password: "", password2: "" });
    const [error, setError] = useState("");
    const [notice, setNotice] = useState("");
    const [saving, setSaving] = useState(false);

    const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    function reset() {
        setForm({ current_password: "", password: "", password2: "" });
        setError("");
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setError("");
        setNotice("");

        if (form.password !== form.password2) {
            setError("Those new passwords do not match.");
            return;
        }

        setSaving(true);
        try {
            const res = await fetch(`${API_BASE_URL}/api/auth/password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    current_password: form.current_password,
                    password: form.password,
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                setError(data.message || "Could not change your password.");
                setSaving(false);
                return;
            }
            reset();
            setOpen(false);
            // Deliberately not claiming other devices were signed out. There is
            // no token revocation yet, so existing sessions stay valid until
            // they expire; saying otherwise would be a false reassurance.
            setNotice(
                "Password updated. Sessions already signed in elsewhere stay " +
                "active until they expire."
            );
        } catch {
            setError("Network error. Your password was not changed.");
        }
        setSaving(false);
    }

    if (!open) {
        return (
            <>
                {notice && <div className="wb-note wb-note--ok">{notice}</div>}
                <button
                    className="wb-btn wb-btn--secondary"
                    onClick={() => { setNotice(""); setOpen(true); }}
                >
                    Change password
                </button>
            </>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <label className="wb-field">
                <span className="wb-label">Current password</span>
                <input
                    className="wb-input" name="current_password" type="password"
                    autoComplete="current-password" required autoFocus
                    value={form.current_password} onChange={change}
                />
            </label>

            <label className="wb-field">
                <span className="wb-label">New password</span>
                <input
                    className="wb-input" name="password" type="password"
                    autoComplete="new-password" required
                    value={form.password} onChange={change}
                />
                <span className="wb-hint">
                    At least 8 characters, with an upper and lower case letter, a
                    number, and one of @$!%*?&amp;
                </span>
            </label>

            <label className="wb-field">
                <span className="wb-label">Confirm new password</span>
                <input
                    className="wb-input" name="password2" type="password"
                    autoComplete="new-password" required
                    value={form.password2} onChange={change}
                />
            </label>

            <div className="wb-row">
                <button type="submit" className="wb-btn wb-btn--primary" disabled={saving}>
                    {saving ? "Updating…" : "Update password"}
                </button>
                <button
                    type="button" className="wb-btn wb-btn--secondary"
                    onClick={() => { reset(); setOpen(false); }}
                >
                    Cancel
                </button>
            </div>

            {error && <div className="wb-note wb-note--danger" style={{ marginTop: "1rem" }}>{error}</div>}
        </form>
    );
}
